import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Modal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    handleToggleModal: PropTypes.func,
    title: PropTypes.string,
    buttons: PropTypes.any
  };

  style = {
    closed: {
      display: "block",
      pointerEvents: "none"
    },
    wrapperOpenedStyle: {
      display: "block",
      opacity: 1,
      background: "rgba(0, 0, 0, 0.5)"
    },

    dialogOpenedStyle: {
      transform: "translate(0, 0)"
    }
  };

  render = () => {
    const { open, buttons, title, content } = this.props;

    return (
      <div
        className="modal fade add-item item-details-modal"
        style={open ? this.style.wrapperOpenedStyle : this.style.closed}
      >
        <div
          className="modal-dialog modal-lg"
          style={open ? this.style.dialogOpenedStyle : null}
        >
          <div className="modal-content">
            <div className="modal-header">
              {buttons()}
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">{content}</div>
          </div>
        </div>
      </div>
    );
  };
}
